import { ActionButton } from "./ActionButton";
import { TClickAction } from "../dataTypes";

export const createButtons = (clickActions: TClickAction[]): React.ReactElement[] =>
  clickActions.map((btn, index) => <ActionButton key={index} config={btn} />);
